import React from 'react'
import { useTranslation } from 'react-i18next'

import { TA_CSS } from './tovarShared'

/**
 * Video-analitika — «tez kunda» sahifasi.
 *
 * Bo'limning o'zi hali qurilmagan: ma'lumot zavoddagi kamera serveri (Vision) dan keladi.
 * Bu sahifa foydalanuvchiga NIMA bo'lishini va u QANDAY ishlashini tushuntiradi —
 * shunda menyu bandini bosgan odam bo'sh ekran ko'rib chalkashmaydi.
 *
 * Arxitektura qarori: docs/adr/ADR-012-vision-app-split.md
 * Bajarish rejasi:   docs/handover/VISION-APP-PLAN.md
 *
 * Uslub — analitika sahifalarining umumiy TA_CSS'i; faqat shu sahifaga xos
 * bir necha klass VA_CSS da (umumiy uslubga tegilmaydi).
 */

const VA_CSS = `
.va-pill{display:inline-flex;align-items:center;gap:6px;background:#fffbeb;color:#d97706;border:1px solid #fde68a;border-radius:20px;padding:5px 13px;font-size:12px;font-weight:800;letter-spacing:.02em;white-space:nowrap}
.va-soon{padding:26px 18px 24px;text-align:center}
.va-soon-ic{width:52px;height:52px;border-radius:14px;background:#f3effc;color:#6f42c1;display:grid;place-items:center;font-size:24px;margin:0 auto 13px}
.va-soon h5{margin:0 0 6px;font-size:16px;font-weight:800;color:#0f172a}
.va-soon p{margin:0 auto;max-width:560px;font-size:13.5px;color:#64748b;line-height:1.65}
.va-desc{font-size:12.5px;color:#64748b;margin-top:6px;line-height:1.55}
.va-title{font-size:20px;font-weight:800;color:#0f172a;line-height:1.15;margin-top:7px;padding-right:36px}
.va-steps{list-style:none;margin:0;padding:0}
.va-steps li{display:flex;gap:11px;padding:11px 18px;border-bottom:1px solid #f1f5f9;font-size:13.5px;color:#0f172a;align-items:flex-start}
.va-steps li:last-child{border-bottom:0}
.va-steps .n{flex:0 0 21px;height:21px;border-radius:6px;background:#f8fafc;border:1px solid #eef2f7;color:#64748b;font-size:11.5px;font-weight:800;display:grid;place-items:center;margin-top:1px}
.va-steps .tx b{font-weight:700}
.va-steps .tx span{display:block;color:#64748b;font-size:12.5px;margin-top:2px;line-height:1.5}
.va-note{display:flex;gap:10px;align-items:flex-start;background:#f8fafc;border:1px solid #eef2f7;border-radius:12px;padding:13px 15px;font-size:12.5px;color:#64748b;line-height:1.6}
.va-note i{color:#6f42c1;font-size:15px;line-height:1.3}
`

function VideoAnalytics() {
	const { t } = useTranslation()

	// Kelgusi 3 hisobot — Vision loyihasi ma'lumot yuborgach shu bo'limda chiqadi
	const reports = [
		{ key: 'machines', icon: 'uil-processor', bg: '#f3effc', color: '#6f42c1' },
		{ key: 'presence', icon: 'uil-users-alt', bg: '#eff6ff', color: '#2563eb' },
		{ key: 'visitors', icon: 'uil-user-arrows', bg: '#fef2f2', color: '#dc2626' },
	]

	return (
		<>
			<style>{TA_CSS}{VA_CSS}</style>

			<div className="ta">
				<div className="ta-head">
					<div>
						<h4>{t('video_analytics')}</h4>
						<div className="ta-hint">{t('va_hint')}</div>
					</div>
					<div className="va-pill">
						<i className="uil-clock"></i>{t('coming_soon')}
					</div>
				</div>

				{/* Tayyorlanmoqda */}
				<div className="ta-block">
					<div className="va-soon">
						<div className="va-soon-ic"><i className="uil-video"></i></div>
						<h5>{t('va_preparing')}</h5>
						<p>{t('va_preparing_hint')}</p>
					</div>
				</div>

				{/* Nima bo'ladi — 3 hisobot */}
				<div className="ta-kpis">
					{reports.map((r, i) => (
						<div className="ta-kpi" key={r.key}>
							<div className="ta-kpi-ic" style={{ background: r.bg, color: r.color }}>
								<i className={r.icon}></i>
							</div>
							<div className="ta-kpi-l">{t('va_report')} {i + 1}</div>
							<div className="va-title">{t(`va_${r.key}`)}</div>
							<div className="va-desc">{t(`va_${r.key}_desc`)}</div>
						</div>
					))}
				</div>

				{/* Qanday ishlaydi */}
				<div className="ta-block">
					<div className="ta-block-h">
						<i className="uil-info-circle"></i>{t('va_how')}
					</div>
					<ul className="va-steps">
						{[1, 2, 3, 4].map(n => (
							<li key={n}>
								<span className="n">{n}</span>
								<span className="tx">
									<b>{t(`va_s${n}`)}</b>
									<span>{t(`va_s${n}_d`)}</span>
								</span>
							</li>
						))}
					</ul>
				</div>

				<div className="va-note">
					<i className="uil-info-circle"></i>
					<div>{t('va_note')}</div>
				</div>
			</div>
		</>
	)
}

export default VideoAnalytics
